var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"brand-logo",style:(_vm.brandLogoStyles)},[_vm._v(" Benefit"),_c('span',{staticClass:"brand-logo__second"},[_vm._v("Buddy")])])}
var staticRenderFns = []

export { render, staticRenderFns }